export class CheckInRequest {
  driverName: string = '';
  licensePlate: string = '';
  driverMobile: string = '';
};
